import dict from '@custom/dict'

export default {
    props: {
    },
    components: {
    },
    data () {
        return {
            dict
        }
    },
    methods: {
    }
}
